import agreements from './agreements'
import domains from './domains'
import info from './info'
import unpaidDomains from './unpaidDomains'
import projects from './projects'

export default {
  namespaced: true,
  modules: {
    agreements,
    domains,
    info,
    unpaidDomains,
    projects
  }
}
